import React from 'react';

const DescriptionField = ({ label, className, input, meta, after, groupComponent }) => (
    <div className={`form-group ${(groupComponent) ? 'input-group' : '' }`}>
        <label htmlFor="textarea">{label}</label>
        <textarea className={className} id="textarea" rows="5" {...input}></textarea>
        {meta.error && meta.touched && <span className="pl-1 small text-danger">{meta.error}</span>}
        {after}
    </div>
);

export default DescriptionField;


// WEBPACK FOOTER //
// ./src/components/DescriptionField.js